import React from 'react';
import cx from 'classnames';

import type {ExtendedSizeModifier} from '../../../types/sizes';
import {sizeToSpacing} from '../../../utils/helpers';

import styles from './Row.module.scss';

export const Row: React.FC<
    React.ComponentProps<'div'> & {spacing?: ExtendedSizeModifier}
> = ({children, className, spacing = 'small', ...props}) => (
    <div
        className={cx(styles.row, styles[sizeToSpacing(spacing)], className)}
        {...props}
    >
        {children}
    </div>
);
